import { formatDate } from '@/lib/utils'
import { TableCell, TableRow } from '@/components/ui/table'

export interface AdminUser {
  id: string
  email: string
  display_name: string | null
  is_active: boolean
  created_at: string
  last_login_at: string | null
}

export function UserRow({ user }: { user: AdminUser }) {
  const initial = (user.display_name ?? user.email).charAt(0).toUpperCase()

  return (
    <TableRow className="border-border hover:bg-popover transition-colors">
      <TableCell>
        <div className="flex items-center gap-3 min-w-0">
          <div
            className={`size-7 rounded-md ring-1 ring-inset flex items-center justify-center font-mono text-xs font-medium shrink-0 ${
              user.is_active
                ? 'bg-primary/10 ring-primary/30 text-primary'
                : 'bg-secondary ring-border text-muted-foreground'
            }`}
          >
            {initial}
          </div>
          <div className="min-w-0">
            <div className="text-sm font-medium truncate">
              {user.display_name ?? user.email}
            </div>
            {!user.is_active && (
              <div className="font-mono text-[9px] uppercase tracking-wider text-destructive">
                Deactivated
              </div>
            )}
          </div>
        </div>
      </TableCell>
      <TableCell className="font-mono text-xs text-muted-foreground">
        {user.email}
      </TableCell>
      <TableCell className="font-mono text-xs text-muted-foreground tabular-nums">
        {formatDate(user.created_at)}
      </TableCell>
      <TableCell className="font-mono text-xs text-muted-foreground tabular-nums">
        {user.last_login_at ? formatDate(user.last_login_at) : '—'}
      </TableCell>
      <TableCell className="text-right">
        <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
          {user.is_active ? 'Active' : 'Disabled'}
        </span>
      </TableCell>
    </TableRow>
  )
}
